/**
 * RepeatRateService
 * 
 * Measures OS-level repeat delay and repeat rate.
 */
export class RepeatRateService extends EventTarget {
  constructor() {
    super();
    this.isMeasuring = false;
    this.targetCode = null;
    this.events = []; // timestamps
    this.awaitingFirstKey = false;
  }

  startMeasurement(code = null) {
    this.isMeasuring = true;
    this.targetCode = code;
    this.events = [];
    this.awaitingFirstKey = code === null;
  }

  recordKeyDown(code, timestamp) {
    if (!this.isMeasuring) return;

    if (this.targetCode === null) {
      this.targetCode = code;
      this.awaitingFirstKey = false;
    }

    if (code !== this.targetCode) return;

    this.events.push(timestamp);

    if (this.events.length >= 10) {
      this.calculate();
    }
  }

  calculate() {
    if (this.events.length < 2) return;

    const delay = this.events[1] - this.events[0];
    
    const intervals = [];
    for (let i = 2; i < this.events.length; i++) {
      intervals.push(this.events[i] - this.events[i-1]);
    }

    const avgRate = intervals.length > 0 
      ? intervals.reduce((a, b) => a + b, 0) / intervals.length 
      : 0;

    this.isMeasuring = false;
    this.dispatchEvent(new CustomEvent('repeatmeasured', {
      detail: {
        code: this.targetCode,
        delay: Math.round(delay),
        rate: Math.round(avgRate)
      }
    }));
  }

  reset() {
    this.isMeasuring = false;
    this.targetCode = null;
    this.events = [];
    this.awaitingFirstKey = false;
  }
}

export const repeatRateService = new RepeatRateService();
